import FeatureSection from "../../components/FeatureSection";

function RealEstateFeatures() {
  return (
    <div>
      {/* First Block */}
      <FeatureSection
        eyebrow="Features"
        title="How Zola Supports Property Management Providers"
        description="At Zola, we know that client experience is everything in real estate. That’s why we built a platform to collect feedback seamlessly from buyers, sellers, and renters across channels—helping you elevate service, build trust, and grow your reputation."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f63029570ff9833cb4aafa_blond-businessman-happy-expression.jpg"
      />

      {/* Second Block (reverse layout) */}
      <FeatureSection
        eyebrow="Features"
        title="Grow Reviews"
        description="You can collect customer reviews for your business on platforms like Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fa4712fb9f0a20b7f491bb_Group%201000005193.png"
        reverse
      />

      {/* Third Block */}
      <FeatureSection
        eyebrow="Features"
        title="Reward your team for generating more reviews"
        description="Motivate your team to proactively seek customer reviews by launching a well-structured incentive program. Boost participation by recognizing and rewarding top performers, fostering engagement and strengthening your brand’s reputation."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fa492d99ca2b9e1787e2f1_Group%201000005198%20(1).png"
      />

      {/* Fourth Block */}
      <FeatureSection
        eyebrow="Features"
        title="Incentivize reviews through leaderboards"
        description="Use leaderboards to drive engagement by tapping into the power of friendly competition, motivating customers to leave more reviews and increase overall participation."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f63ad3a90139b37dbe605d_Frame%202085664985%20(1).png"
        reverse
      />

      {/* Fifth Block */}
      <FeatureSection
        eyebrow="Features"
        title="Motivate your team to enhance Net Promoter Scores (NPS) and Customer Satisfaction (CSAT)"
        description="Inspire your team with targeted incentives to boost Net Promoter Scores (NPS) and Customer Satisfaction (CSAT), fostering outstanding customer experiences."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f77b04cdf52c2ab2299469_Frame%202085664986.png"
      />

      {/* Sixth Block */}
      <FeatureSection
        eyebrow="Features"
        title="AI Generated Surveys"
        description="You can create AI-generated surveys to streamline data collection and gain valuable insights for your business."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f77d71c670b8a7a2365ccf_Frame%201618869449%20(2).png"
        reverse
      />

      {/* Seventh Block */}
      <FeatureSection
        eyebrow="Features"
        title="Coupons"
        description="You can create exclusive coupons for your customers to encourage repeat business and enhance customer loyalty."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f77f26c6a6a19f4deb1ba7_Frame%202085664987.png"
      />

      <FeatureSection
        eyebrow="Features"
        title="Campaigns"
        description="You can create exclusive coupons for your customers to encourage repeat business and enhance customer loyalty."
        image="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f7844ed491c5bc75ede30d_Frame%201618869448%20(2).png"
        reverse
      />
    </div>
  );
}

export default RealEstateFeatures;
